module.exports = __webpack_public_path__ + "static/media/layers-3.1c866cec.svg";